import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRastereditIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 29.753 29.592",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M86.118,85.816v-9.9a2.445,2.445,0,1,0-3.073-3.1l-20.294-6.77a2.432,2.432,0,1,0-3.073,3.1L63.034,89.2a2.445,2.445,0,1,0,3.073,3.1l16.938-3.385a2.432,2.432,0,1,0,3.073-3.1ZM83.046,87.36,66.107,90.745a2.449,2.449,0,0,0-1.53-1.544l-3.356-20.05a2.449,2.449,0,0,0,1.53-1.544l20.294,6.77a2.449,2.449,0,0,0,1.53,1.544v9.9A2.449,2.449,0,0,0,83.046,87.36Z",
		transform: "translate(-58.022 -64.379)"
	})
});
export default SvgRastereditIcon;
